import React, { useState, useEffect } from 'react';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Header from '../../common/components/Header/Header';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import { staticData } from 'gatsby-env-variables';
import Stepper from '../../components/Stepper/Stepper';
import Applicant from '../../images/icons/applicant.svg';
import { navigate } from 'gatsby';
import PropertyStarter from '../../common/components/PropertStarter/PropertyStarter';
import SideImage from '../../images/icons/KYCComplete.svg';

const PropertyStarterFlow = () => {
  const [applicantInformation, setApplicantInformation] = useState(
    localStorage.hasOwnProperty('ApplicantUserKycInfo')
      ? JSON.parse(localStorage.getItem('ApplicantUserKycInfo'))
      : false
  );

  let stepsText = ['KYC', 'Income', 'Property'];
  const icons = {
    1: <div className="text-lg">1</div>,
    2: <div className="text-lg">2</div>,
    3: <div className="text-lg">3</div>
  };
  const ApplicantClick = () => {
    navigate(`/app/leadprofile`);
  };

  return (
    <React.Fragment>
      <Helmet title={`Property  | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full  font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="w-full bg-grey-alabastersolid max-screen">
            <div className="w-full ">
              <Header />
              <div className="w-full flex">
              <div className="md:ml-5  w-full md:w-8/12 px-2 md:bg-white min-h-screen md:py-2">
                  <div
                    className="w-12 px-1 py-1 text-center cursor-pointer"
                    onClick={ApplicantClick}
                  >
                    <img
                      className="mr-auto w-full  rounded-md"
                      src={Applicant}
                    />
                    <p
                      className="font-roboto font-normal text-black-500 mx-auto"
                      style={{ fontSize: '10px' }}
                    >
                      {applicantInformation?.name
                        ? `${applicantInformation?.name?.firstName} ${applicantInformation?.name?.lastName}`
                        : 'Applicant'}
                    </p>
                  </div>

                  <div className="overflow-x-auto">
                    <Stepper
                      activeStep={2}
                      stepsText={stepsText}
                      stepIcons={icons}
                      styles={{ backgroundColor: '#EBF2F958' }}
                    />
                  </div>
                  <div className="pt-8 w-full">
                    <PropertyStarter />
                  </div>
                </div>
                <div className="w-1/4 hidden md:block">
                  <img
                    className="inset-x-0 bottom-0"
                    src={SideImage}
                    style={{ position: 'fixed', bottom: 0, left: '80%' }}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default PropertyStarterFlow;
